// IE 2026 09 28 / ODOO-342342: «Бизнес-кейсы» — полоса пути (GuideBar): шаги пути, «назад / далее», текущий шаг, «пройдено» по шагам, прогресс.
// Шаги — path.steps ответа play_plan (контракт v1 §6.1: {n, id, kind, title, stage, minutes, status, soon, playable, note}) либо строки с номером n
// из _doc.items_view карточки пути (§4.1). Номер шага — n бэка (с 1), позиция в пути — индекс в списке. Отметка «пройдено» — одна на кейс
// (любого пути: done[id]), у шага-не-кейса (якорь / страница / виджет прямо в пути) — по id шага.
// Кейс с несколькими якорями без пути — «виды» кейса: те же Next / Back по якорям (anchors ответа play_plan).

const isObj = (x) => !!(x && typeof x === 'object')
const str = (v) => (v === undefined || v === null) ? '' : String(v)
const identityT = (text, params) => String(text || '').replace(/\{(\w+)\}/g, (m, k) => (params && k in params) ? String(params[k]) : m)

export function guidePath_normStep(s, i = 0) {
    if (!isObj(s)) return null
    const n = Number(s.n)
    const m = Number(s.minutes)
    return {
        n: Number.isFinite(n) && n > 0 ? n : i + 1,
        id: str(s.id || s.node?.value),
        kind: str(s.kind || 'case'),
        title: str(s.title || s.node?.valueStr || s.id),
        stage: str(s.stage),
        minutes: Number.isFinite(m) && m > 0 ? m : null,
        status: str(s.status),
        status_title: str(s.status_title),
        cls: str(s['cssClass-status'] || s.cls),
        soon: !!s.soon,
        playable: s.playable === undefined ? !s.soon : !!s.playable && !s.soon,
        note: str(s.note),
        check_failed: str(s.check_status) === 'uc-status-check-failed',
    }
}

// шаги из ответа play_plan (path.steps)
export function guidePath_fromPlan(path) {
    const list = isObj(path) && Array.isArray(path.steps) ? path.steps : []
    return list.map((s, i) => guidePath_normStep(s, i)).filter(Boolean).sort((a, b) => a.n - b.n)
}

// шаги из строк _doc.items_view карточки пути: листья с номером n, в порядке номеров; этап — заголовок ближайшей группы-этапа
export function guidePath_fromRows(rows) {
    const out = []
    const rec = (list, stage) => {
        for (const r of list || []) {
            if (!isObj(r)) continue
            const isStage = r.kind === 'stage' || r.node?.attr_type === 'AttrTab'
            if (!isStage && r.n != null && Number(r.n) > 0) {
                const st = guidePath_normStep({ ...r, id: r.node?.value, title: r.node?.valueStr, stage }, out.length)
                if (st) out.push(st)
            }
            rec(r.attrs, isStage ? str(r.node?.valueStr) : stage)
        }
    }
    rec(rows, '')
    return out.sort((a, b) => a.n - b.n)
}

export function guidePath_index(steps, n) {
    const i = (steps || []).findIndex(s => s.n === Number(n))
    return i
}
// следующий / предыдущий шаг (индексы; за краем — тот же): «скоро» и неиграбельные шаги не пропускаются — показываются карточкой / текстом
export function guidePath_next(steps, i) { const L = (steps || []).length; return L ? Math.min(L - 1, Math.max(0, i + 1)) : -1 }
export function guidePath_prev(steps, i) { const L = (steps || []).length; return L ? Math.max(0, Math.min(L - 1, i - 1)) : -1 }
export function guidePath_hasNext(steps, i) { return i >= 0 && i < (steps || []).length - 1 }
export function guidePath_hasPrev(steps, i) { return i > 0 && i < (steps || []).length }

// прогресс: пройдено шагов (isDone(id, step)), всего, процент, минуты пройденных / всех
export function guidePath_progress(steps, isDone = () => false) {
    const list = steps || []
    let done = 0, minTotal = 0, minDone = 0
    for (const s of list) {
        let d = false
        try { d = !!isDone(s.id, s) } catch (e) { d = false }
        if (d) done++
        minTotal += s.minutes || 0
        if (d) minDone += s.minutes || 0
    }
    const total = list.length
    return { done, total, pct: total ? Math.round(100 * done / total) : 0, minutesDone: Math.round(minDone * 10) / 10, minutesTotal: Math.round(minTotal * 10) / 10 }
}

// подписи полосы
export function guidePath_label(i, total, t = identityT) {
    if (!(total > 0) || i < 0) return ''
    return t('Step {i} of {n}', { i: i + 1, n: total })
}
export function guidePath_progressText(p, t = identityT, opts = {}) {
    if (!p || !p.total) return ''
    const parts = [t('{done} of {total} done', { done: p.done, total: p.total })]
    if (p.minutesTotal && opts.minutes !== false) parts.push(t('{n} min', { n: p.minutesTotal }))
    return parts.join(' · ')
}

// с какого шага начать путь: сохранённое место (pos — номер шага), иначе первый играбельный (есть что открыть в демо: якорь / страница / виджет),
// иначе первый не «скоро» (IE 2026 09 28 / ODOO-342342, приёмка Н2: не Planned / Idea — зритель начинал с карточки «Coming soon»), иначе первый
export function guidePath_startIndex(steps, pos) {
    const list = steps || []
    if (!list.length) return -1
    const byPos = pos ? guidePath_index(list, pos) : -1
    if (byPos >= 0) return byPos
    const firstPlayable = list.findIndex(s => s.playable && !s.soon)
    if (firstPlayable >= 0) return firstPlayable
    const firstShown = list.findIndex(s => !s.soon)   // IE 2026 09 28 / ODOO-342342 (Н2)
    return firstShown >= 0 ? firstShown : 0
}
// IE 2026 09 28 / ODOO-342342 (приёмка Н2): шаг, которого в демо не показать (Planned / Idea или без якоря), — приглушён в полосе и в карточке пути
export function guidePath_dim(st) { return !!st && (!!st.soon || !st.playable) }

export default { guidePath_normStep, guidePath_fromPlan, guidePath_fromRows, guidePath_index, guidePath_next, guidePath_prev, guidePath_hasNext, guidePath_hasPrev, guidePath_progress, guidePath_label, guidePath_progressText, guidePath_startIndex, guidePath_dim }
